<template>
  <div class="flex justify-center gap-6 mx-auto max-w-home">
    <div class="w-full max-w-screen-2xl overflow-hidden">
      <slot />
    </div>
  </div>
</template>
